import { createContext, useContext } from 'react';

type ReorderContextValue = {
  enabled: boolean;
};

export const ReorderContext = createContext<ReorderContextValue>({
  enabled: true,
});

export const useReorderContext = () => useContext(ReorderContext);
